import Paragraph from "./Paragraph";
import Text from "./Text";
import Title from "./Title";

export { Paragraph, Text, Title };
